import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Tabs, Tab} from '@material-ui/core';
import {useSubcontractorsStore} from '../SubcontractorsStore';

function TabsView(props) {
  const {state: {sentInvitations}} = useSubcontractorsStore();
  const sentInvitationsCount = sentInvitations.list.length;

  return (
    <Tabs
      value={props.currentNav}
      onChange={props.onTabSelect}
      TabIndicatorProps={{style: {backgroundColor: '#E72580'}}}
      textColor="primary"
    >
      <Tab
        data-id="tab-subcontractors-list"
        value="/list"
        label={<div className="m-0"><Translate value="subcontractor.mySubcontractors"/></div>}
      />
      <Tab
        data-id="tab-subcontractors-invitations-sent"
        value="/invitations-sent"
        label={
          <div className="m-0">
            <Translate value="subcontractor.invitations.sent"/>
            <span className="separator information">{sentInvitationsCount}</span>
          </div>
        }
      />
      <Tab
        data-id="tab-invalid-documents"
        value="/invalid-organisation-documents"
        label={<div className="m-0"><Translate value="invalidOrganisationDocuments.title"/></div>}
      />
    </Tabs>
  );
}

TabsView.propTypes = {
  currentNav: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  onTabSelect: PropTypes.func.isRequired
};

export default TabsView;
